import React, { useState } from 'react';
import { Button, Row, Col, Form, FormGroup, Label, Input } from 'reactstrap';

const ProfileStep = ({ onComplete, onBack }) => {
  const [formData, setFormData] = useState({
    name: '',
    lastName: '',
    companyName: '',
    phone: '',
    timezone: 'America/Mexico_City'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onComplete(formData);
  };

  return (
    <div className="onboarding-step profile-step-fullscreen">
      <Row className="justify-content-center">
        <Col lg={10} xl={8}>
          <div className="step-header-fullscreen mb-4">
            <Button 
              color="link" 
              className="back-btn"
              onClick={onBack}
            >
              <i className="mdi mdi-arrow-left"></i> Volver
            </Button>
            
            <h1 className="step-title-large mb-2">
              Completa tu perfil
            </h1>
            <p className="step-description-large">
              Esta información permite que Claryo ejecute tus procesos correctamente
            </p>
          </div>

          <Form onSubmit={handleSubmit}>
            <div className="profile-form-card">
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label className="form-label-large">Nombre completo</Label>
                    <Input 
                      type="text" 
                      placeholder="Tu nombre"
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      className="form-input-large"
                    />
                    <small className="form-help-text">
                      Para personalizar las comunicaciones automáticas de Claryo
                    </small>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label className="form-label-large">Apellido</Label>
                    <Input 
                      type="text" 
                      placeholder="Tu apellido"
                      value={formData.lastName}
                      onChange={(e) => setFormData({...formData, lastName: e.target.value})}
                      className="form-input-large"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label className="form-label-large">Nombre de tu empresa</Label>
                    <Input 
                      type="text" 
                      placeholder="Nombre de empresa"
                      value={formData.companyName}
                      onChange={(e) => setFormData({...formData, companyName: e.target.value})}
                      className="form-input-large"
                    />
                    <small className="form-help-text">
                      Claryo ejecutará los procesos bajo este nombre
                    </small>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label className="form-label-large">Teléfono</Label>
                    <Input 
                      type="tel" 
                      placeholder="+52 123 456 7890"
                      value={formData.phone}
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                      className="form-input-large"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label className="form-label-large">Zona horaria</Label>
                    <Input 
                      type="select"
                      value={formData.timezone}
                      onChange={(e) => setFormData({...formData, timezone: e.target.value})}
                      className="form-input-large"
                    >
                      <option value="America/Mexico_City">America/Mexico_City (GMT-6)</option>
                      <option value="America/New_York">America/New_York (GMT-5)</option>
                      <option value="America/Los_Angeles">America/Los_Angeles (GMT-8)</option>
                      <option value="America/Chicago">America/Chicago (GMT-6)</option>
                      <option value="America/Denver">America/Denver (GMT-7)</option>
                      <option value="America/Phoenix">America/Phoenix (GMT-7)</option>
                      <option value="America/Bogota">America/Bogota (GMT-5)</option>
                      <option value="America/Santiago">America/Santiago (GMT-3)</option>
                      <option value="America/Buenos_Aires">America/Buenos_Aires (GMT-3)</option>
                    </Input>
                    <small className="form-help-text">
                      Para que las automatizaciones se ejecuten en el horario correcto
                    </small>
                  </FormGroup>
                </Col>
              </Row>

              <div className="form-actions-fullscreen mt-4">
                <Button 
                  color="primary" 
                  size="lg"
                  type="submit"
                  className="onboarding-primary-btn w-100"
                >
                  Continuar
                  <i className="mdi mdi-arrow-right ms-2"></i>
                </Button>
              </div>
            </div>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default ProfileStep;

